import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from 'src/environments/config.model';
import { environment } from 'src/environments/environment';
import { ItineraryService } from '../search-result/services/itinerary.service';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TransactionIdInterceptor implements HttpInterceptor {
  env: Config = environment;
  api = this.env.urlBase;

  pnrInfo = new BehaviorSubject(null);

  constructor(private itineraryService: ItineraryService) {
    this.itineraryService.getPnrInfo().subscribe(this.pnrInfo);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.rules(req.url) && !this.rulesad(req) && req.method == 'POST') {
      const transactionId = this.pnrInfo.getValue().transactionId;
      req.body.transactionId = transactionId;
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (this.rules(req.url) && this.rulesad(req)) {
            if (event.body && event.body.transactionId) {
              localStorage.setItem('transactionId', event.body.transactionId);
            }
          }
        }
      })
    );
  }

  /**
   * @param url
   * TODO CRAETE A VALIDATION WHEN YOU VERIFY THAT THE URL IT'S THE SAME
   */

  rules(url: any) {
    const evt = url.split('/');
    return (
      (evt.length == 8 && this.validGds(evt[6])) ||
      (evt.length == 7 && evt[5] == 'search' && evt[6] == 'tickets')
    );
  }

  validGds(gds) {
    return gds == 'sabre' || gds == 'amadeus' || gds == 'worldspan';
  }

  rulesad(request) {
    return (
      request.url !== `${this.env.urlAdminBase}${this.env.users}` ||
      request.url !== `${this.env.urlAuthority}/connect/token` ||
      request.url !== `${this.env.urlAuthority}/.well-known/openid-configuration/jwks`
    );
  }
}
